import React, { useEffect } from "react";
import "./Carrer_Tooksoff.css";

import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper/modules";

import "swiper/css";
import "swiper/css/pagination";

import { useDispatch, useSelector } from "react-redux";
import { AllSuccessStory } from "../../../features/admin/common/Slice";
import { IDS } from "../../../utils/IDS";

const Carrer_Tooksoff = () => {
  // const testimonials = [
  //   {
  //     id: 1,
  //     name: "Sonu Buradkar",
  //     role: "Software Engineer II",
  //     edu: "B.E. Computer",
  //     package: "30 LPA",
  //     image: "/assets/images/home/carrer_tooksoff/logo-1.png",
  //     review:
  //       "The DSA classes and mentorship were the best part. Regular sessions improved my problem-solving & System Design skills. A great upskilling experience overall.",
  //   },
  //   {
  //     id: 2,
  //     name: "Sonu Buradkar",
  //     role: "Software Engineer II",
  //     edu: "B.E. Computer",
  //     package: "30 LPA",
  //     image: "/assets/images/home/carrer_tooksoff/logo-1.png",
  //     review:
  //       "The DSA classes and mentorship were the best part. Regular sessions improved my problem-solving & System Design skills. A great upskilling experience overall.",
  //   },
  //   {
  //     id: 3,
  //     name: "Sonu Buradkar",
  //     role: "Software Engineer II",
  //     edu: "B.E. Computer",
  //     package: "30 LPA",
  //     image: "/assets/images/home/carrer_tooksoff/logo-1.png",
  //     review:
  //       "The DSA classes and mentorship were the best part. Regular sessions improved my problem-solving & System Design skills. A great upskilling experience overall.",
  //   },
  //   {
  //     id: 4,
  //     name: "Sonu Buradkar",
  //     role: "Software Engineer II",
  //     edu: "B.E. Computer",
  //     package: "30 LPA",
  //     image: "/assets/images/home/carrer_tooksoff/logo-1.png",
  //     review:
  //       "The DSA classes and mentorship were the best part. Regular sessions improved my problem-solving & System Design skills. A great upskilling experience overall.",
  //   },
  //   {
  //     id: 5,
  //     name: "Sonu Buradkar",
  //     role: "Software Engineer II",
  //     edu: "B.E. Computer",
  //     package: "30 LPA",
  //     image: "/assets/images/home/carrer_tooksoff/logo-1.png",
  //     review:
  //       "The DSA classes and mentorship were the best part. Regular sessions improved my problem-solving & System Design skills. A great upskilling experience overall.",
  //   },
  // ];

  const dispatch = useDispatch();
  const successStories = useSelector((state) => state.common.all_success_story);

  useEffect(() => {
    dispatch(AllSuccessStory());
  }, [dispatch]);
  return (
    <section className="Carrer_Tooksoff">
      <div className="container">
        <div className="Carrer_Tooksoff_header">
          <h5 className="Carrer_Tooksoff_title">
            Where Careers <span>Took Off</span>
          </h5>

          <span className="header_img">
            <img
              src="/assets/images/home/carrer_tooksoff/title-img.png"
              alt="title-img"
              className="title_img"
            />
          </span>
        </div>

        <div className="testimonial_section">
          <Swiper
            modules={[Pagination, Autoplay]}
            autoplay={{
              delay: 3000,
              disableOnInteraction: false,
            }}
            spaceBetween={20}
            slidesPerView={3}
            // centeredSlides={true}
            loop={true}
            // pagination={{ clickable: true }}
            breakpoints={{
              0: { slidesPerView: 1 },
              320: { slidesPerView: 1.2 },
              574: { slidesPerView: 2 },
              768: { slidesPerView: 2.5 },
              992: { slidesPerView: 3 },
              1200: { slidesPerView: 3 },
            }}
            className="testimonial_swiper"
          >
            {successStories.map((item, index) => (
              <SwiperSlide key={index}>
                <div className="testimonial_card">
                  <div className="testimonial_header">
                    <img
                      src={`${IDS.IMG_URL}${item.image}`}
                      alt={item.name}
                      className="profile_img"
                    />
                    <div className="header_item">
                      <h5>{item.name}</h5>
                      <p>{item.designation}</p>
                    </div>
                  </div>

                  <div className="info_strip">
                    <div>
                      <p>
                        <strong>Edu Background:</strong> {item.edu_background}
                      </p>
                    </div>
                    <div>
                      <p>
                        <strong>Package:</strong> {item.package}
                      </p>
                    </div>
                  </div>

                  <p className="review_text">"{item.description}"</p>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    </section>
  );
};

export default Carrer_Tooksoff;
